<template>
  <h-delete-dropdown-item
    :focused="focused"
    :deleting="deleting"
    @delete="deletingHandler"
  />
</template>

<script>
import { bus } from "@/components/spaces/bus.js";

export default {
  props: ["focused", "deleting"],
  methods: {
    deletingHandler() {
      bus.$emit("deleting-event");
    },
  },
};
</script>
